/* --------------------------------------------------------------------------------------
   clientSearchPopup.component.js

   Copyright © 2019 Xerox Corporation. All Rights Reserved.
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const clientSearchPopupComponent = {
  template: require("./clientSearchPopup.html"),
  bindings: {
    display: "=",
    selected: "=",
    onNodeSwitch: "&",
    onClose: "&",
  },
  controllerAs: "vm",
  controller: class clientSearchPopupCtrl {
    /*@ngInject*/
    constructor(browserService, commonService, $timeout, $state) {
      this.browserService = browserService;
      this.commonService = commonService;
      this.$timeout = $timeout;
      this.$state = $state;
    }

    async $onInit() {
      this.screenSize = await this.commonService.getScreenSize();
      this.clientSearchTerms = "";
      this.searching = false;
      this.searchFinished = false;
      this.clientSearchResults = [];
      this.selected = [];
      angular.element("#client-search-message-table-wrapper").height("1250px");
    }

    async clientSearch() {
      if (this.clientSearchTerms.trim().length < 3) {
        angular.element("#empty-search-term-banner").xrxbanner("call");
        return;
      }

      this.searching = true;
      this.getKeyboard().accept();

      try {
        const response = await this.browserService.getNode(
          null,
          "Clients",
          "root",
          this.clientSearchTerms.trim()
        );

        this.clientSearchResults = response.Children;

        this.searching = false;
        this.searchFinished = true;

        this.updatePopupTableScroll();

        this.commonService.updateView();
      } catch (error) {
        this.searching = false;
        this.commonService.updateView();
      }
    }

    updatePopupTableScroll() {
      angular
        .element("#client-search-result-table-wrapper")
        .xrxscrollable("destroy");
      setTimeout(() => {
        if (this.hasScroll()) {
          angular
            .element("#client-search-result-table-wrapper")
            .removeClass("no-scroll");
          angular.element("#client-search-result-table-wrapper").xrxscrollable({
            scroll: true,
            height: this.screenSize === 7 ? 286 : 384,
          });
          angular
            .element("#client-search-result-table-wrapper .shadow")
            .removeClass("hide");
        } else {
          angular
            .element("#client-search-result-table-wrapper")
            .addClass("no-scroll");
          angular
            .element("#client-search-result-table-wrapper")
            .xrxscrollable("destroy");
          angular
            .element("#client-search-result-table-wrapper .shadow")
            .addClass("hide");
        }
        this.commonService.updateView();
      }, 500);
    }

    hasScroll() {
      return this.screenSize === 7
        ? this.clientSearchResults.length * 69 > 286
        : this.clientSearchResults.length * 63 > 384;
    }

    clientSearchTermChanged() {
      this.clientSearchTermsBackup = angular.copy(
        this.clientSearchTerms.trim()
      );
    }

    clientSearchTermCancel() {
      this.$timeout(
        () => (this.clientSearchTerms = this.clientSearchTermsBackup),
        50
      );
    }

    ok() {
      this.selected = this.clientSearchResults.filter((r) => r.selected);
      this.clientSearchResults = [];
      this.getKeyboard().accept();
      this.closePopup();
    }

    cancel() {
      this.getKeyboard().accept();
      this.closePopup();
    }

    closePopup() {
      this.clientSearchResults = [];
      this.display = false;
      this.onClose();
      this.commonService.updateView();
    }

    getKeyboard() {
      return angular.element("#client-search-input").getkeyboard();
    }

    getSelected() {
      if (!this.hasOwnProperty("clientSearchResults")) return [];
      return this.clientSearchResults.filter((item) => item.selected);
    }

    getResultsTableHeight() {
      const maxHeight = this.screenSize === 7 ? 286 : 384;
      const rowHeight = this.screenSize === 7 ? 66 : 60;
      const totalHeight = this.clientSearchResults.length * rowHeight;
      return Math.min(maxHeight, totalHeight);
    }

    async select(node) {
      if (node.EntryType !== "Document") {
        this.selected = node;
        this.browserService.selectedClientId = node.ID;
        this.browserService.selectedClientDisplayName = node.DisplayName;
      } else {
        this.updateSelectedNodes(node);
      }
      await this.commonService.updateView();
    }

    updateSelectedNodes(node) {
      if (!this.selected.includes(node)) this.selected.push(node);
      else this.selected = this.selected.filter((n) => n != node);
    }

    async handleClientSelect(item) {
      await this.select(item);
      this.onNodeSwitch();
      this.display = false;
      this.commonService.updateView();
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/browser/components/clientSearchPopup.component.js